"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = transformedVideoInputs;
var _types = require("../../actions/meeting/types");
function transformedVideoInputs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_TRANSFORMED_VIDEO_INPUTS) {
    return action.payload;
  }
  return state;
}